/*
 * a: number (work), b: number (work), af: number (free in row), bf: number (free in row), freeInRow: number (group setting)
 */
const compare = (a, b, af, bf, freeInRow) => {
  // a work less than b
  if (a < b) {
    // a has half the work than b then omit free in row rule
    if(a * 2 < b){
      return -1;
    }

    if(af > 0 && af % freeInRow !== 0 && af > bf){
      return 1;
    }

    // af is set larger than due to free in row rule
    return -1;
  }
  // a work more than b
  if (a > b) {
    // a has double the work than b then omit free in row rule
    if(a * 0.5 > b){
      return 1;
    }

    if(bf > 0 && bf % freeInRow !== 0 && bf > af){
      return -1;
    }

    // af is set larger than due to free in row rule
    return 1;
  }

  if(af > 0 && af % freeInRow !== 0 && af > bf){
    return 1;
  }
  
  if(bf > 0 && bf % freeInRow !== 0 && bf > af){
    return -1;
  }

  return 0;
};

// a and b are statistic row
const compareEmployeeOrderNumber = (a, b) => {
  if (a.employee.orderNumber < b.employee.orderNumber) {            
    return -1;
  }
  if (a.employee.orderNumber > b.employee.orderNumber) {            
    return 1;
  }
  return 0;
};

const compareOrderNumber = (a, b) => {
  if (a.orderNumber < b.orderNumber) {            
    return -1;
  }
  if (a.orderNumber > b.orderNumber) {            
    return 1;
  }
  return 0;
};

const isActive = (day, weekdays) => {
  if(!weekdays || weekdays.length === 0){
    return true;
  }
  let isActive = true;
  switch(day){
    case 1: // Monday
      isActive = !weekdays.find(o => o.id === 2) || weekdays.find(o => o.id === 2).isChecked;
      break;
      
    case 2: 
      isActive = !weekdays.find(o => o.id === 4) || weekdays.find(o => o.id === 4).isChecked;
      break;
      
    case 3: 
      isActive = !weekdays.find(o => o.id === 8) || weekdays.find(o => o.id === 8).isChecked;
      break;
      
    case 4: 
      isActive = !weekdays.find(o => o.id === 16) || weekdays.find(o => o.id === 16).isChecked;
      break;
      
    case 5: 
      isActive = !weekdays.find(o => o.id === 32) || weekdays.find(o => o.id === 32).isChecked;
      break;
      
    case 6: // Saturday
      isActive = !weekdays.find(o => o.id === 64) || weekdays.find(o => o.id === 64).isChecked;
      break;

    case 7: // Sunday
      isActive = !weekdays.find(o => o.id === 1) || weekdays.find(o => o.id === 1).isChecked;
      break;
  }
  return isActive;
};

export {
  isActive, 
  compare,
  compareEmployeeOrderNumber,
  compareOrderNumber,
  
}
